// @flow

import React from 'react';
import type { ColorScheme } from '../../../../types/theme';
import Icon from './icon';

type Props = {
  scheme: ColorScheme,
};

const Plus = ({ scheme }: Props) => <Icon icon="plus" scheme={scheme} />;

export default Plus;
